import { createSelector } from '@reduxjs/toolkit';
import { selectSubsidizedMortgageValue } from '../subsidizedMortgage';
import { SUBSIDIZED_MORTGAGE_OPTION_VALUE } from 'shared/constants/subsidizedMortgage';
import { selectPromoSearchTypes as selectAllPromoSearchTypes } from 'shared/selectors/jsonQuery';
import { getPromoSearchFilterValuesByType } from 'shared/utils/promoSearchTypes';
import { selectPromoSearchTypes } from 'shared/selectors/promoSearchTypes';

export const selectMortgagePromoSearchTypeValue = createSelector(
  [selectSubsidizedMortgageValue, selectAllPromoSearchTypes, selectPromoSearchTypes],
  (isSubsidizedMortgage, allPromoSearchTypeValues, promoSearchTypes) => {
    const result: string[] = [];

    if (isSubsidizedMortgage) {
      result.push(SUBSIDIZED_MORTGAGE_OPTION_VALUE);
    }

    if (allPromoSearchTypeValues && promoSearchTypes) {
      const availableFilterValues = getPromoSearchFilterValuesByType('mortgage', promoSearchTypes);
      const filteredValues = allPromoSearchTypeValues.filter(value => availableFilterValues.includes(value));

      result.push(...filteredValues);
    }

    return result.length ? result : [null];
  },
);
